var _style, _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYesIconsIconFast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 108 100.2",
    style: {
      enableBackground: "new 0 0 108 100.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#fff;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 6.7,
    className: "st0",
    width: 81.2,
    height: 87.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.6,94.2c-0.6,0-1.3-0.3-1.7-0.8l-9-10c-0.8-0.9-0.8-2.1,0-3l9-10c0.8-1,2.2-1.1,3.2-0.3 c0.5,0.4,0.8,1.1,0.8,1.8v3.8c15.7-1.3,27.3-15.1,26-30.8c-1.2-14.7-13.5-26-28.3-26.1c-1.3,0-2.3-1-2.3-2.3c0-1.3,1-2.3,2.3-2.3 c18.2,0,33,14.8,33,33s-14.8,33-33,33c-1.3,0-2.3-1-2.3-2.3v-0.3L47.7,82l3.6,4v-0.3c0-1.3,1-2.3,2.3-2.3 c19.9,0,36.1-16.1,36.1-36.1c0-19.9-16.1-36.1-36.1-36.1c-19.9,0-36.1,16.1-36.1,36.1c0,10.8,4.8,21,13.1,27.9 c1,0.8,1.1,2.2,0.3,3.2c-0.8,1-2.2,1.1-3.2,0.3C10.5,64.4,8.1,38.8,22.3,21.5s39.9-19.7,57.1-5.5S99.2,56,84.9,73.2 c-7.2,8.7-17.7,14.1-29,14.7v4c0,0.9-0.6,1.8-1.5,2.1C54.2,94.1,53.9,94.2,53.6,94.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.6,52.7c-1.3,0-2.3-1-2.3-2.3v-23c0.1-1.3,1.2-2.2,2.4-2.1c1.1,0.1,2,1,2.1,2.1v23 C55.9,51.7,54.9,52.7,53.6,52.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.4,52.7H53.6c-1.3,0-2.3-1-2.3-2.3c0-1.3,1-2.3,2.3-2.3l0,0h12.8c1.3,0,2.3,1,2.3,2.3 C68.7,51.7,67.7,52.7,66.4,52.7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.8,19c-1.3,0-2.3-1-2.3-2.3c0-1.2,0.9-2.1,2.1-2.2c1-0.1,2-0.1,3-0.1c1.3,0,2.3,1,2.3,2.3 c0,1.3-1,2.3-2.3,2.3c0,0,0,0,0,0l0,0c-0.8,0-1.7,0-2.6,0.1H50.8z M36.6,24c-1.3,0-2.3-1-2.3-2.3c0-0.8,0.4-1.5,1-1.9 c2.3-1.5,4.7-2.7,7.3-3.6c1.2-0.5,2.5,0.1,3,1.3s-0.1,2.5-1.3,3c-0.1,0-0.1,0.1-0.2,0.1c-2.2,0.8-4.3,1.8-6.3,3.1 C37.5,23.9,37.1,24,36.6,24 M26.5,35c-0.4,0-0.7-0.1-1.1-0.3c-1.1-0.6-1.5-2-0.9-3.1c0,0,0,0,0,0c1.3-2.4,2.9-4.6,4.7-6.6 c0.9-0.9,2.3-0.9,3.2,0c0.8,0.8,0.9,2.1,0.1,3c-1.6,1.7-2.9,3.7-4,5.7C28.2,34.5,27.4,35,26.5,35 M22.9,49.6c-1.3,0-2.3-1-2.3-2.3 c0,0,0,0,0,0c0-2.7,0.3-5.4,1-8.1c0.3-1.2,1.6-1.9,2.8-1.6c1.2,0.3,1.8,1.5,1.6,2.7c-0.6,2.3-0.9,4.6-0.9,7 C25.1,48.6,24.1,49.6,22.9,49.6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesIconsIconFast);
export default __webpack_public_path__ + "static/media/YES-ICONS_ICON-FAST.b5e5db1a9acc56cf803634688ac08054.svg";
export { ForwardRef as ReactComponent };